import { Card, Form, InputNumber, Modal, Input, Button, message } from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";

function pickAr(overlay) {
  return typeof overlay?.ar === "string" ? overlay.ar : "";
}

export default function NutritionSection({
  setAdditionalNutrition,
  initialAdditional = [],
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [label, setLabel] = useState("");
  const [labelAr, setLabelAr] = useState("");
  const [value, setValue] = useState("");
  const [additionalList, setAdditionalList] = useState([]);

  useEffect(() => {
    if (initialAdditional?.length) {
      const cloned = initialAdditional.map((item) => ({
        ...item,
        labelAr: pickAr(item.labelI18n) || item.labelAr || "",
      }));
      setAdditionalList(cloned);
      syncParent(cloned);
    }
  }, [initialAdditional]);

  const normalize = (str) => str.trim().toLowerCase();

  const syncParent = (list) => {
    const cleaned = list.map(({ labelAr: ar, labelI18n, ...rest }) => {
      const next = {
        label: rest.label,
        value: rest.value,
      };
      const arTrim = (ar || pickAr(labelI18n) || "").trim();
      if (arTrim) next.labelI18n = { ar: arTrim };
      return next;
    });
    setAdditionalNutrition(cleaned);
  };

  const handleAdd = () => {
    const cleanLabel = label.trim();
    const cleanLabelAr = labelAr.trim();
    const cleanValue = value.trim();

    if (!cleanLabel || !cleanValue) {
      message.warning("Both fields are required");
      return;
    }

    const exists = additionalList.some(
      (item) => normalize(item.label) === normalize(cleanLabel)
    );

    if (exists) {
      message.warning("This nutrition key already exists");
      return;
    }

    const updatedList = [
      ...additionalList,
      {
        label: cleanLabel,
        labelAr: cleanLabelAr,
        value: cleanValue,
      },
    ];

    setAdditionalList(updatedList);
    syncParent(updatedList);

    setLabel("");
    setLabelAr("");
    setValue("");
    setIsModalOpen(false);
  };

  const removeItem = (index) => {
    const updated = additionalList.filter((_, i) => i !== index);
    setAdditionalList(updated);
    syncParent(updated);
  };

  return (
    <Card className="recipe-section">
      <div className="section-title">
        <span className="section-bar" />
        <h3>2. Nutrition Data</h3>
      </div>

      <div className="nutrition-grid">
        <Form.Item
          label="Calories (kcal)*"
          name={["nutrition", "calories"]}
          rules={[{ required: true, message: "Calories is required" }]}
        >
          <InputNumber
            placeholder="0.00"
            min={0}
            controls={false}
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          label="Protein (g)*"
          name={["nutrition", "protein"]}
          rules={[{ required: true, message: "Protein is required" }]}
        >
          <InputNumber
            placeholder="0.00"
            min={0}
            controls={false}
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          label="Carbs (g)*"
          name={["nutrition", "carbs"]}
          rules={[{ required: true, message: "Carbs is required" }]}
        >
          <InputNumber
            placeholder="0.00"
            min={0}
            controls={false}
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          label="Fat (g)*"
          name={["nutrition", "fat"]}
          rules={[{ required: true, message: "Fat is required" }]}
        >
          <InputNumber
            placeholder="0.00"
            min={0}
            controls={false}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </div>

      {additionalList.length > 0 && (
        <div className="nutrition-grid" style={{ marginTop: 16 }}>
          {additionalList.map((item, index) => (
            <Form.Item
              key={index}
              label={
                item.labelAr
                  ? `${item.label} / ${item.labelAr}`
                  : item.label
              }
              style={{ marginBottom: 0 }}
            >
              <div style={{ display: "flex", gap: 8 }}>
                <Input value={item.value} disabled />
                <CloseOutlined
                  style={{ cursor: "pointer", marginTop: 10 }}
                  onClick={() => removeItem(index)}
                />
              </div>
            </Form.Item>
          ))}
        </div>
      )}

      <div
        className="add-nutrition-link"
        onClick={() => setIsModalOpen(true)}
        style={{ cursor: "pointer", marginTop: 12 }}
      >
        <PlusOutlined /> Add Nutrition Data
      </div>

      <Modal
        title="Add Nutrition data"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setLabel("");
          setLabelAr("");
          setValue("");
        }}
        footer={null}
      >
        <div style={{ marginBottom: 12 }}>
          <div style={{ marginBottom: 6 }}>Key</div>
          <Input
            placeholder="eg. Fiber"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: 12 }}>
          <div style={{ marginBottom: 6 }}>Key (Arabic)</div>
          <Input
            placeholder="مثال: الألياف"
            value={labelAr}
            dir="rtl"
            onChange={(e) => setLabelAr(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 6 }}>Value</div>
          <Input
            placeholder="eg. 5g"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </div>

        <Button
          type="primary"
          block
          size="large"
          className="submit-btn"
          onClick={handleAdd}
        >
          Add
        </Button>
      </Modal>
    </Card>
  );
}
